import { h, Host } from "@stencil/core";
export class TabButton {
    constructor() {
        this.name = "";
        this.activeTab = undefined;
        this.tabId = "";
        this.active = false;
    }
    domNode;
    componentWillLoad() {
        this.active = this.activeTab === this.tabId;
    }
    updateTabButtonName(e) {
        if (e.detail.tabId === this.tabId) {
            this.name = e.detail.tabName;
        }
    }
    render() {
        return (h(Host, { key: 'eded96262293d21714029190f9e3f59c37666b2a', tabindex: 0, role: "tab", "aria-selected": this.active ? "true" : "false", class: `ux-tab-button ${this.active ? "is-active" : ""}` }, h("div", { key: '8e2a3949278d48b48bbaa439ad6afe97c99a5a61', class: "ux-tab-button__label", id: this.tabId }, h("slot", { key: '16ba48317d56c05602bda9f902b77f1c3845274f' }), this.name)));
    }
    static get is() { return "ux-tab-button"; }
    static get originalStyleUrls() {
        return {
            "$": ["tab-button.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tab-button.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Displays the label of the tab"
                },
                "attribute": "name",
                "reflect": true,
                "defaultValue": "\"\""
            },
            "activeTab": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Contains the current active tab string"
                },
                "attribute": "active-tab",
                "reflect": true
            },
            "tabId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Contains this tabs ID"
                },
                "attribute": "tab-id",
                "reflect": true,
                "defaultValue": "\"\""
            }
        };
    }
    static get states() {
        return {
            "active": {}
        };
    }
    static get elementRef() { return "domNode"; }
    static get watchers() {
        return [{
                "propName": "activeTab",
                "methodName": "componentWillLoad"
            }];
    }
    static get listeners() {
        return [{
                "name": "uxTabNameChange",
                "method": "updateTabButtonName",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=tab-button.js.map
